import { words } from './words';
export function kebabCase(str) {
    return words(str).join('-');
}
